<template>
  <div :style="mapStyle" class="comAmap" ref="amap">
    <div class="reset" @click="handleReset">
      <i class="iconfont">&#xe639;</i>
    </div>
  </div>
</template>
<script>
import VueTypes from 'vue-types'
import utils from 'gkSrc/utils'

export default {
  name: 'com-amap',
  components: {
  },
  props: {
    info: VueTypes.object,
    width: VueTypes.string.def('300px'),
    height: VueTypes.string.def('258px'),
    center: VueTypes.string.def('')
  },
  data () {
    return {
      map: null,
      mapDom: null,
      marker: null
    }
  },
  computed: {
    mapStyle () {
      return {
        width: this.width,
        height: this.height
      }
    },
    position () {
      if (this.center !== '') {
        let arr = this.center.split(',')
        return {
          lng: Number(arr[0]),
          lat: Number(arr[1])
        }
      } else {
        return {
          lng: 0,
          lat: 0
        }
      }
    },
    time () {
      return utils.date(this.info.start_time, 'MM 月 DD 日') + '-' + utils.date(this.info.end_time, 'MM 月 DD 日')
    },
    address () {
      return this.info.address
    }
  },
  created () {
  },
  watch: {
    position (newVal) {
      this.map.setZoomAndCenter(16, [newVal.lng, newVal.lat])
      this.marker.setPosition([newVal.lng, newVal.lat])
    }
  },
  mounted () {
    this.mapDom = this.$refs.amap
    this.initMap(this.mapDom)
  },
  beforeDestroy () {
    this.map.destroy()
  },
  methods: {
    handleReset () {
      this.map.setZoomAndCenter(17, [this.position.lng, this.position.lat])
    },
    initMap (dom) {
      let AMap = window.AMap
      this.map = new AMap.Map(dom, {
        resizeEnable: true,
        center: [this.position.lng, this.position.lat],
        zoom: 15,
        features: ['point', 'road', 'building']
      })
      this.marker = this.createMarker(this.position.lng, this.position.lat)
      this.map.add(this.marker)
      this.createInfoWindow()
    },
    createInfoWindow () {
      let _this = this
      let AMap = window.AMap
      
      AMap.event.addListener(_this.marker, 'click', function () {
        var infoWindow = new AMap.InfoWindow({
          content: _this.createInfoWindowContent(_this.info),
          offset: new AMap.Pixel(0, -35)
        })
        infoWindow.open(_this.map, _this.marker.getPosition())
        setTimeout(function () {
          let navTo = document.querySelector('.iw-nav-to')
          navTo.addEventListener('click', function (e) {
            _this.marker.markOnAMAP({
                name: _this.address,
                position: _this.marker.getPosition()
            })
          })
        }, 300)
      })
    },
    createMarker (lng, lat, title = '') {
      let AMap = window.AMap
      let marker = new AMap.Marker({
        position: new AMap.LngLat(lng, lat),
        animation: 'AMAP_ANIMATION_DROP'
      })
      return marker
    },
    createInfoWindowContent (info) {
      let con = `
        <div class="inner-window">
          <div class="iw-time">时间: ${this.time}</div>
          <div class="iw-address">地点: ${this.address}</div>
          <div class="iw-nav-to">到这里去</div>
        </div>
      `
      return con
    },
    closeInfoWindow () {
      this.map.clearInfoWindow()
    }
  }
}
</script>
<style lang="scss">
@import "../../assets/css/_common";
.comAmap {
  position: relative;
  overflow: hidden;
  border-radius: 3px;
}
.reset {
  @extend %center;
  position: absolute; right: 10px; bottom: 10px; z-index: 100;
  width: 24px; height: 24px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0px 0px 5px 0px rgba(36,44,49,0.45);
  cursor: pointer;

  & .iconfont {
    font-size: 18px;
    color: $blue;
  }
}
.inner-window {
  padding: 10px 10px 5px;

  & .iw-time, & .iw-address {
    margin-bottom: 5px;
    @include lineFont(14, 400)
  }

  & .iw-nav-to {
    display: inline-block;
    cursor: pointer;
    padding: 3px;
    border: #ccc 1px solid;
    border-radius: 4px;
    color: $blue;
    @include font(12, 400);
  }
}
</style>
